import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['maskedElement'];

  maskedElementTarget: HTMLElement;

  showUnmaskedDatum() {
    const maskedElement = this.maskedElementTarget;
    const { unmaskedDatum } = maskedElement.dataset;

    // @ts-expect-error TS2322 violates strict null checks
    maskedElement.innerHTML = unmaskedDatum;
  }
}
